export default __webpack_public_path__ + "static/media/html.ea990877.png";